import { Children, JSX, ReactNode } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { GridContainer, IGridContainerProps } from "../Grid/GridContainer";
import { GridItem } from "../Grid/GridItem";

export class Stack extends BaseComponent<IStackProps, IStackState>
{
    public render(): JSX.Element
    {
        const { children, ...gridProps } = this.props;
        const childrenAsArray = Children.toArray(this.props.children);

        return (
            <GridContainer
                {...gridProps}
            >
                {childrenAsArray.map(i => <GridItem compact={12}>{i}</GridItem>)}
            </GridContainer>
        );
    }
}

export interface IStackProps extends IGridContainerProps { }
export interface IStackState { }
